import { NgModule } from '@angular/core';
import { UploadComponent } from './components/upload/upload.component';
import { SharedModule } from '@shared/shared.module';
import { DownloadComponent } from './components/download/download.component';
import { DownloadQrUrlsComponent } from './components/download-qr-urls/download-qr-urls.component';

const components = [UploadComponent, DownloadComponent, DownloadQrUrlsComponent];
@NgModule({
  declarations: [...components],
  imports: [SharedModule],
  exports: [...components],
  providers: [],
})
export class AdministratieModule {}
